export const LEGAL_PICTURE_SUFFIX = ['jpg', 'jpeg', 'png', 'webp', 'bmp'];
